import React, { useEffect, useRef, useState } from "react";
import { useAuthStep } from "@/hooks/useAuthStep";
import { createClient } from "@supabase/supabase-js";
import { Check, Loader2 } from "lucide-react";
import { z } from "zod";
import { CLOUDFLARE_URL, SUPABASE_ANON_KEY, SUPABASE_URL } from "@/lib/config";
import { PublicClientApplication, type Configuration } from "@azure/msal-browser";
import { OutlookSvg } from "@/lib/svg";
import { checkSignupCompletion } from "@/lib/utils";
import { useCommunication } from "@/lib/CommunicationWrapper";
import { useMicrosoftAuth } from "@/hooks/useMicrosoftAuth";
import { useAuth } from "@/lib/auth";


const OutlookLogin = () => {

    const { handleAuth, loginState } = useAuthStep();

    const { microsoftLogin } = useMicrosoftAuth();

    const handleOutlookLogin = async () => {
        const authFn = await microsoftLogin();
        handleAuth(authFn, "login");
    }

    return (
        <>
            <div className="px-[30px] text-gray-500">
                <h1 className="text-2xl font-semibold text-black mb-[5px]">Log in to BetterCampus</h1>
                <p>Over 1.5 million students made their Canvas better.</p>
                <div className="mt-[20px]">
                    <button onClick={handleOutlookLogin} className="w-full flex items-center justify-center gap-2 rounded-md border border-gray-300 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50">
                        {loginState.loading && <span className="text-gray-500 text-sm flex items-center gap-2 mt-2"><Loader2 className="w-4 h-4 animate-spin" /></span>}
                        <OutlookSvg className="size-5" />
                        Sign in with Microsoft
                    </button>
                    {loginState.success && <span className="text-sm flex items-center gap-2 mt-2 text-green-700"><Check className="w-4 h-4" /> Success!</span>}
                </div>
            </div>
        </>
    )
}

export default OutlookLogin;
